module.exports = __webpack_public_path__ + "static/media/2.cd153055.jpg";